module.exports = __webpack_public_path__ + "img/375_news_sub_img5.c6401791.png";